import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { ModalModule } from 'ngx-bootstrap/modal';

import { SharedModule } from 'shared/shared.module';
import { NgUploaderModule } from 'shared/ngx-uploader/modules/ngx-uploader.module';
import { ScrollToService } from 'shared/base/scroll-to.service';
import { SearchPageService } from 'shared/search-page/search-page.service';

import { ImportManagerRoutingModule } from './import-manager-routing.module';
import { ImportManagerComponent } from './import-manager.component';

/* eslint-disable */
import { ImportManagerSearchResultsComponent } from './search/import-manager-search-results/import-manager-search-results.component';
import { ImportManagerSearchResultsRowComponent} from './search/import-manager-search-results-row/import-manager-search-results-row.component';
/* eslint-enable */
import { ViewReportBtnComponent } from './search/view-report-btn/view-report-btn.component';
import { ImportManagerSearchService } from './search/import-manager-search.service';
import { ReportModalModule } from './component/report-modal/report-modal.module';
import { ImportUploadModalComponent } from './component/import-upload-modal/import-upload-modal.component';


@NgModule({
  imports: [
    CommonModule,
    ModalModule.forRoot(),
    RouterModule,
    FormsModule,
    SharedModule,
    NgUploaderModule,
    ImportManagerRoutingModule,
    ReportModalModule,
  ],
  declarations: [
    ImportManagerComponent,
    ImportManagerSearchResultsComponent,
    ImportManagerSearchResultsRowComponent,
    ViewReportBtnComponent,
    ImportUploadModalComponent,
  ],
  exports: [ImportManagerComponent],
  providers: [
    ScrollToService,
    SearchPageService,
    ImportManagerSearchService,
  ]
})
export class ImportManagerModule { }
